// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__VJYzX","active":"Pagination_active__7Mjw4"};